/**
 * Returns a Generator over a range of numbers. Works in both directions.
 * @param {number} start The first yielded value; can be higher than end
 * @param {number} end The first *not* yielded value; can be lower than start
 * @param {number} [steps=1] The number of steps to take per interval; > 0
 * @return {Generator<number>}
 * @throws {TypeError} if steps <= 0
 */
export function* range(start, end, steps = 1) {
	if (steps < 0.00001) {
		throw new TypeError(`steps "${steps}" <= 0`);
	}

	if (start < end) {
		for (let i = start; i < end; i += steps) {
			yield i;
		}
	} else {
		for (let i = start; end < i; i -= steps) {
			yield i;
		}
	}
}
